import { axiosAuthInstance } from "../../../config/axios-config";

var InvoicesService = {
  getIncomingBills: async function (input) {
    return await axiosAuthInstance
      .get("/invoices/incoming/invoices", { params: { ...input } })
      .then((res) => {
        return res.data;
      });
  },

  getOutgoingBills: async function (input) {
    return await axiosAuthInstance
      .get("/invoices/outgoing/invoices", { params: { ...input } })
      .then((res) => {
        return res.data;
      });
  },

  getBill: async function (id) {
    return await axiosAuthInstance.get(`/invoices/${id}`).then((res) => {
      return res.data;
    });
  },

  getInvoiceById: async function (id) {
    return await axiosAuthInstance.get(`/invoices/${id}`).then((res) => {
      return res.data;
    });
  },

  createExternalInvoice: async function (input) {
    return await axiosAuthInstance
      .post("/invoices/invoice/external", { ...input })
      .then((res) => {
        return res.data;
      });
  },

  createInvoice: async function (input) {
    return await axiosAuthInstance
      .post("/invoices", { ...input })
      .then((res) => {
        return res.data;
      });
  },

  payInvoice: async function (input) {
    return await axiosAuthInstance
      .post("/invoices/pay/invoices", { ...input })
      .then((res) => {
        return res.data;
      });
  },

  deleteInvoice: async function (id) {
    return await axiosAuthInstance.delete(`/invoices/${id}`).then((res) => {
      return res.data;
    });
  },
  //reject an invoice
  rejectInvoice: async function (id, reason) {
    return await axiosAuthInstance
      .put(`/invoices/invoice/reject`, {
        id: id,
        reason: reason,
      })
      .then((res) => {
        return res.data;
      });
  },
};

export default InvoicesService;
